export default "__VITE_ASSET__CBZdiAd5__"